import { useEffect, useRef, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { yourCommentActivity } from "../../redux/ApiSlice/ActivitySlice";
import SkeletonCommentActitivy from "../../components/skeleton/SkeletonCommentActitivy";

// Bug 5 fixed: static constant moved outside component — no longer recreated on every render
const dropDownData = [
    { id: 1, value: "new", name: "Most Recent" },
    { id: 2, value: "old", name: "Oldest" },
];

const Commented = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);
    const [selectedSort, setSelectedSort] = useState("Most Recent");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // Bug 3 fixed: added commentNext and commentLoadingMore for pagination
    const { commentData, loading, commentLoadingMore, commentNext, error } = useSelector((state) => state.YourActivity);

    const currentSort = selectedSort === "Most Recent" ? "new" : "old";

    // Bug 1 + 3 fixed: dispatch now uses object signature { sort } to match updated thunk
    useEffect(() => {
        dispatch(yourCommentActivity({ sort: currentSort }));
    }, [dispatch, currentSort]);

    // Bug 7 fixed: close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Bug 6 fixed: formatDate now includes year — MM-DD-YYYY
    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    // Bug 3 fixed: load next page of comments
    const handleLoadMore = () => {
        if (commentNext && !commentLoadingMore) {
            dispatch(yourCommentActivity({ sort: currentSort, nextUrl: commentNext, isLoadMore: true }));
        }
    };

    const comments = commentData?.results?.comments || [];

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[16px] text-black dark:text-black">
                        Comment History
                    </p>
                </div>
            </div>

            {/* DropDown */}
            {!loading &&
                <div className="mt-4 px-2 flex w-full justify-end">
                    {/* Bug 7 fixed: dropdownRef attached for outside-click detection */}
                    <div className="relative w-[7.7rem]" ref={dropdownRef}>
                        <button
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            className="w-full px-2 py-1 rounded-md bg-white dark:bg-[#333333] text-black dark:text-white border-2 whitespace-nowrap border-[#BDE6FF] dark:border-[#333333] text-[14px] flex items-center justify-between gap-2"
                        >
                            {selectedSort}
                            <IoIosArrowDown
                                className={`transition-transform text-black dark:text-white ${isDropdownOpen ? 'rotate-180' : ''}`}
                            />
                        </button>

                        {isDropdownOpen && (
                            <div className="absolute right-0 mt-1 w-full bg-white dark:bg-[#333333] rounded-md shadow-lg z-10 overflow-hidden">
                                {dropDownData
                                    .filter(item => item.name !== selectedSort)
                                    .map((item) => (
                                        <div
                                            key={item.id}
                                            onClick={() => {
                                                setSelectedSort(item.name);
                                                setIsDropdownOpen(false);
                                            }}
                                            className="px-2 py-1 whitespace-nowrap text-[14px] hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-gray-800 dark:text-white"
                                        >
                                            {item.name}
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>
            }

            <div className="mt-4">
                {loading ? (
                    <SkeletonCommentActitivy />
                ) : error ? (
                    <div className="flex justify-center items-center py-8">
                        <p className="text-red-500 text-[14px]">Error: {error}</p>
                    </div>
                ) : comments.length === 0 ? (
                    <div className="flex justify-center items-center py-8">
                        <p className="text-gray-500 text-[14px]">No comments yet</p>
                    </div>
                ) : (
                    <>
                        {comments.map((item) => (
                            <div key={item.comment_id} className="flex items-start mb-4 border-b border-gray-300 dark:border-gray-800/50 last:border-b-0 px-2 pb-2">
                                <div className="flex-1">
                                    {/* Bug 6 fixed: date now shows MM-DD-YYYY */}
                                    <p className="text-[10px] text-black dark:text-white mt-1">{formatDate(item.created_on)}</p>
                                    <p className="text-xs text-black dark:text-white">You Commented:</p>
                                    <p className="text-[12px] w-[75%] font-bold text-black dark:text-white line-clamp-2">{item.comment}</p>
                                </div>
                                <div className="flex flex-col items-end">
                                    {/* Bug 2 fixed: onError fallback prevents broken image icon */}
                                    <img
                                        onClick={() => navigate(`/v/${item.post.id}`, { state: { fromComment: true, postId: item.post.id } })}
                                        alt="Media"
                                        src={item.post.thumbnail_url}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "";
                                            e.target.style.background = "#d1d5db";
                                        }}
                                        className="w-[3rem] h-[4rem] rounded object-cover cursor-pointer ml-3 bg-gray-300 dark:bg-gray-700"
                                    />
                                    <p
                                        onClick={() => navigate(`/account/${item.post.created_by.id}`, { state: { fromComment: true, postId: item.post.id } })}
                                        className="text-[10px] text-black dark:text-white mt-1 line-clamp-1 text-center cursor-pointer"
                                    >
                                        @{item.post.created_by.username}
                                    </p>
                                </div>
                            </div>
                        ))}

                        {/* Bug 3 fixed: pagination — load more comments on demand */}
                        {commentNext && (
                            <div className="flex justify-center py-4">
                                {commentLoadingMore ? (
                                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900 dark:border-white" />
                                ) : (
                                    <button
                                        onClick={handleLoadMore}
                                        className="px-4 py-2 text-[13px] font-semibold bg-[#BDE6FF] text-black rounded-lg active:scale-95 transition-transform"
                                    >
                                        Load More
                                    </button>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default Commented
